import { styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar, Typography } from '@mui/material';

import LanguagePopover from '../../../components/LanguagePopover';

// ----------------------------------------------------------------------

export default function MainHeader() {
  return (
    <RootStyle>
      <Toolbar
        sx={{
          minHeight: '100% !important',
          px: 3,
          borderRadius: '23px',
          bgcolor: '#fff',
        }}
      >
        <Typography variant="h5" color="#000" sx={{ fontWeight: 500, mt: 0.3 }} lineHeight={1}>
          Awesome Traffic Bot
        </Typography>
        <Box sx={{ flexGrow: 1 }} />

        <Stack direction="row" alignItems="center" spacing={{ xs: 0.5, sm: 1.5 }}>
          <LanguagePopover />
        </Stack>
      </Toolbar>
    </RootStyle>
  );
}

// ----------------------------------------------------------------------
const RootStyle = styled(AppBar)(({ theme }) => ({
  backgroundColor: '#F5F5F5',
  boxShadow: 'none',
  height: 110,
  zIndex: theme.zIndex.appBar + 1,
  paddingRight: 24,
  paddingLeft: 24,
  paddingTop: 18,
  paddingBottom: 18,
  margin: 0,
}));
